import { Get, Post, Put, Delete } from '../../api/axiosCoreConfig';

export const getLaboratoryFactors = ({ offset = 0, limit = 100, search, namespace }) =>
    Get('/lab_test/factor', { params: { search, offset, limit, namespace } });

export const getLaboratoryTest = (patient_id, offset = 0, limit = 20, namespace) =>
    Get('/lab_test/recent', { params: { patient_id, offset, limit, namespace } });

/**
 * @param {{patient_id: number,issued_datetime: string,report_datetime: string,values: {factor_id: number,value: string}[]}} data
 */
export const createLaboratoryResult = (data) => Post('/lab_test/result', data);

/**
 * @param {number} result_id
 * @param {{issued_datetime: string,report_datetime: string,values: {factor_id: number,value: string}[]}} data
 */
export const editLaboratoryResult = (result_id, data) => Put(`/lab_test/result/${result_id}`, data);

/**
 *
 * @param {number} result_id
 */
export const deleteLaboratoryResult = (result_id, namespace) =>
    Delete(`/lab_test/result/${result_id}?namespace=${namespace}`);

/**
 * @param {{patient_id: number,issued_datetime: string,report_datetime: string,image: string}} data
 */
export const createLaboratoryImageResult = (data) =>
    Post('/lab_test/images_result', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });

/**
 * @param {number} imagesResultId
 */
export const deleteLaboratoryImageResult = (imagesResultId, namespace) =>
    Delete(`/lab_test/images_result/${imagesResultId}?namespace=${namespace}`);

/**
 * @param {FormData} data
 * @description data ---> FormData of image
 */
export const addImageToLaboratoryImageResult = (imagesResultId, data) =>
    Post(`/lab_test/images_result/${imagesResultId}/image`, data);

/**
 * @param {number} imagesResultId
 * @param {number} imageId
 */
export const deleteImageFromLaboratoryImageResult = (imagesResultId, imageId, namespace) =>
    Delete(`/lab_test/images_result/${imagesResultId}/image/${imageId}?namespace=${namespace}`);
